import Service from "../../AuthService";
const payment = {
    getPurchasePayment(page) {
        return Service.get("/purchase_payment?page="+page);
    },
    showPurchasePayment(id) {
        return Service.get("/purchase_payment/"+id);
    },
    createPurchasePayment(data) {
        return Service.post("/purchase_payment" ,data);
    },
    updatePurchasePayment(id,data) {
        return Service.put("/purchase_payment/"+id ,data);
    },
    deletePurchasePayment(id){
        return Service.delete("/purchase_payment/"+id );
    },
    getPaymentDetails(page) {
        return Service.get("/purchase_payment_details");
    },
    showPaymentDetails(id) {
        return Service.get("/purchase_payment_details/"+id);
    },
    createPurchasePaymentDetails(data) {
        return Service.post("/purchase_payment_details" ,data);
    },
    updatePurchasePaymentDetails(id,data) {
        return Service.put("/purchase_payment_details/"+id ,data);
    },
    deletePurchasePaymentDetails(id){
        return Service.delete("/purchase_payment_details/"+id );
    },
    purchasePaymentSearch(data){
        return Service.get("/payment_search?date="+data.date+"&name="+data.name+"&vendor_id="+data.vendor_id)
    }
};
export default payment;
